import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import _ from 'lodash';

import { COMMON_REQUEST_DATETIME_FORMAT } from 'constants/date';
import { getConditionalObject } from 'utils/data';

dayjs.extend(utc);

export const buildApiFilters = ({
  statuses,
  requestType,
  vendorName,
  createdAfter,
  createdBefore,
}) => ({
  ...getConditionalObject(statuses.length > 0, () => ({
    statuses: statuses.map(s => s.id),
  })),
  ...getConditionalObject(requestType.trim().length > 0, () => ({
    requestTypeContains: requestType.trim(),
  })),
  ...getConditionalObject(vendorName.trim().length > 0, () => ({
    vendorNameContains: vendorName.trim(),
  })),
  ...getConditionalObject(!_.isNil(createdAfter), () => ({
    createdAfter: createdAfter.startOf('day').utc().format(COMMON_REQUEST_DATETIME_FORMAT),
  })),
  ...getConditionalObject(!_.isNil(createdBefore), () => ({
    createdBefore: createdBefore.endOf('day').utc().format(COMMON_REQUEST_DATETIME_FORMAT),
  })),
});
